<template>
	<div>
		<Template>
			<div class="dashboard-container p-4">
				<!-- Section Principale - Statistiques clés -->
				<div class="row mb-4 g-4">
					<!-- Carte Présence -->
					<div class="col-xl-6 col-lg-12">
						<div class="dashboard-card h-100">
							<div class="card-header">
								<h5 class="card-title">{{ $t('dashboard.express_management') }}</h5>
								<h3 class="card-subtitle">{{ $t('dashboard.at_post') }}</h3>
							</div>
							<div class="chart-container">
								<canvas id="presence" height="350"></canvas>
							</div>
						</div>
					</div>
					
					<!-- Carte Salaires -->
					<div class="col-xl-6 col-lg-12">
						<div class="dashboard-card h-100">
							<div class="card-header">
								<h5 class="card-title">{{ $t('dashboard.express_management') }}</h5>
								<h3 class="card-subtitle">{{ $t('dashboard.wage_margin') }}</h3>
							</div>
							<div class="chart-container">
								<canvas id="salary" height="350"></canvas>
							</div>
						</div>
					</div>
				</div>
				
				<!-- Section Secondaire - 3 cartes moyennes -->
				<div class="row mb-4 g-4">
					<!-- Carte Ventes -->
					<div class="col-xl-4 col-lg-6 col-md-12">
						<div class="dashboard-card h-100">
							<div class="card-header">
								<h5 class="card-title">{{ $t('dashboard.sales') }}</h5>
								<h3 class="card-subtitle">{{ $t('dashboard.amounts') }}</h3>
							</div>
							<div class="chart-container">
								<canvas id="sales" height="250"></canvas>
							</div>
						</div>
					</div>
					
					<!-- Carte Achats -->
					<div class="col-xl-4 col-lg-6 col-md-12">
						<div class="dashboard-card h-100">
							<div class="card-header">
								<h5 class="card-title">{{ $t('dashboard.buyings') }}</h5>
								<h3 class="card-subtitle">{{ $t('dashboard.amounts') }}</h3>
							</div>
							<div class="chart-container">
								<canvas id="buyings" height="250"></canvas>
							</div>
						</div>
					</div>
					
					<!-- Carte Formation -->
					<div class="col-xl-4 col-lg-6 col-md-12">
						<div class="dashboard-card h-100">
							<div class="card-header">
								<h5 class="card-title">{{ $t('dashboard.training') }}</h5>
								<h3 class="card-subtitle">{{ $t('dashboard.nature') }}</h3>
							</div>
							<div class="chart-container">
								<canvas id="training" height="250"></canvas>
							</div>
						</div>
					</div>
				</div>
				
				<!-- Section Tertiaire - 6 petites cartes -->
				<div class="row g-4">
					<!-- Carte Documents -->
					<div class="col-xl-4 col-lg-6 col-md-6">
						<div class="dashboard-card h-100">
							<div class="card-header">
								<h5 class="card-title">{{ $t('dashboard.document') }}</h5>
								<h3 class="card-subtitle">{{ $t('dashboard.library') }}</h3>
							</div>
							<div class="chart-container">
								<canvas id="document" height="200"></canvas>
							</div>
						</div>
					</div>
					
					<!-- Carte Type de contrat -->
					<div class="col-xl-4 col-lg-6 col-md-6">
						<div class="dashboard-card h-100">
							<div class="card-header">
								<h5 class="card-title">{{ $t('dashboard.job_offer') }}</h5>
								<h3 class="card-subtitle">{{ $t('dashboard.type') }}</h3>
							</div>
							<div class="chart-container">
								<canvas id="job_contract" height="200"></canvas>
							</div>
						</div>
					</div>
					
					<!-- Carte Statut des offres -->
					<div class="col-xl-4 col-lg-6 col-md-6">
						<div class="dashboard-card h-100">
							<div class="card-header">
								<h5 class="card-title">{{ $t('dashboard.job_offer') }}</h5>
								<h3 class="card-subtitle">{{ $t('global.status') }}</h3>
							</div>
							<div class="chart-container">
								<canvas id="job_status" height="200"></canvas>
							</div>
						</div>
					</div>
					
					<!-- Carte Genre candidats -->
					<div class="col-xl-4 col-lg-6 col-md-6">
						<div class="dashboard-card h-100">
							<div class="card-header">
								<h5 class="card-title">{{ $t('dashboard.candidat_profils') }}</h5>
								<h3 class="card-subtitle">{{ $t('global.sex') }}</h3>
							</div>
							<div class="chart-container">
								<canvas id="application_gender" height="200"></canvas>
							</div>
						</div>
					</div>
					
					<!-- Carte Statut candidatures -->
					<div class="col-xl-4 col-lg-6 col-md-6">
						<div class="dashboard-card h-100">
							<div class="card-header">
								<h5 class="card-title">{{ $t('dashboard.candidat_profils') }}</h5>
								<h3 class="card-subtitle">{{ $t('global.status') }}</h3>
							</div>
							<div class="chart-container">
								<canvas id="application_status" height="200"></canvas>
							</div>
						</div>
					</div>
					
					<!-- Carte vide pour équilibre (peut être utilisée pour autre chose) -->
					<div class="col-xl-4 col-lg-6 col-md-6">
						<div class="dashboard-card h-100 d-flex align-items-center justify-content-center">
							<div class="text-center p-4">
								<h4>{{ $t('home.first_title') }}</h4>
								<p class="mb-0">{{ $t('home.second_title') }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Template>
	</div>
</template>

<script>
import Chart from 'chart.js/auto';
import Template from '@/components/Template.vue';
import Helper from '@/helpers/helper';

export default {
	name: 'DashboardPage',
	components: { Template },
	data() {
		return {
			presence: {},
			salary: [],
			training: {},
			sales: {},
			buyings: {},
			document_labels: [],
			document_numbers: [],
			job_contract_labels: [],
			job_contract_numbers: [],
			job_status_labels: [],
			job_status_numbers: [],
			application_gender_labels: [],
			application_gender_numbers: [],
			application_status_labels: [],
			application_status_numbers: [],
		};
	},
	methods: {
		loadList() {
			this.loading = true;
			fetch(Helper.route('admin/dashboard/stats'), Helper.requestOptions())
				.then((response) => {
					Helper.tokenChecker(response.status);
					return response.json();
				})
				.then((data) => {
					console.log(data);
					this.presence = data.data.presence;
					this.training = data.data.training;
					this.sales = data.data.sale;
					this.buyings = data.data.buying;

					let salary = data.data.salary;
					salary.forEach((item) => {
						this.salary.push(item.number);
					});

					let document = data.data.document;
					document.forEach((item) => {
						this.document_numbers.push(item.number);
						this.document_labels.push(
							Helper.capitalize(Helper.truncate(item.folder, 10))
						);
					});

					let job_contract = data.data.jobContract;
					job_contract.forEach((item) => {
						this.job_contract_labels.push(Helper.capitalize(item.contract));
						this.job_contract_numbers.push(item.number);
					});

					let job_status = data.data.jobStatus;
					job_status.forEach((item) => {
						this.job_status_labels.push(Helper.capitalize(item.status));
						this.job_status_numbers.push(item.number);
					});

					let application_gender = data.data.applicantGender;
					application_gender.forEach((item) => {
						this.application_gender_labels.push(Helper.capitalize(item.gender));
						this.application_gender_numbers.push(item.number);
					});

					let application_status = data.data.applicationStatus;
					application_status.forEach((item) => {
						this.application_status_labels.push(Helper.capitalize(item.status));
						this.application_status_numbers.push(item.number);
					});

					this.initCharts();
				})
				.catch((error) => {
					console.log(error);
				});
		},
		
		initCharts() {
			this.presenceChart();
			this.salaryChart();
			this.trainingChart();
			this.documentChart();
			this.jobContractChart();
			this.jobStatusChart();
			this.applicationGenderChart();
			this.applicationStatusChart();
			this.salesChart();
			this.buyingsChart();
		},
		
		presenceChart() {
			const ctx = document.getElementById('presence').getContext('2d');
			new Chart(ctx, {
				type: 'doughnut',
				data: {
					labels: ['Au poste', 'En congé', 'En vacances'],
					datasets: [{
						data: [
							this.presence.present,
							this.presence.conges,
							this.presence.vacances,
						],
						backgroundColor: ['#4BC0C0', '#36A2EB', '#FFCE56'],
						borderWidth: 0,
					}]
				},
				options: {
					cutout: '70%',
					plugins: {
						legend: {
							position: 'bottom',
							labels: {
								font: {
									size: 12
								},
								padding: 20
							}
						},
						tooltip: {
							bodyFont: {
								size: 14
							}
						}
					}
				}
			});
		},
		
		salaryChart() {
			const ctx = document.getElementById('salary').getContext('2d');
			new Chart(ctx, {
				type: 'bar',
				data: {
					labels: ['0-80k', '80k-150k', '150k-250k', '250k-500k', '500k+'],
					datasets: [{
						label: 'Nombre employés',
						data: this.salary,
						backgroundColor: [
							'rgba(75, 192, 192, 0.7)',
							'rgba(54, 162, 235, 0.7)',
							'rgba(255, 159, 64, 0.7)',
							'rgba(255, 99, 132, 0.7)',
							'rgba(153, 102, 255, 0.7)'
						],
						borderColor: [
							'rgba(75, 192, 192, 1)',
							'rgba(54, 162, 235, 1)',
							'rgba(255, 159, 64, 1)',
							'rgba(255, 99, 132, 1)',
							'rgba(153, 102, 255, 1)'
						],
						borderWidth: 1
					}]
				},
				options: {
					responsive: true,
					scales: {
						y: {
							beginAtZero: true,
							ticks: {
								font: {
									size: 12
								}
							}
						},
						x: {
							ticks: {
								font: {
									size: 12
								}
							}
						}
					},
					plugins: {
						legend: {
							display: false
						}
					}
				}
			});
		},
		
		trainingChart() {
			const ctx = document.getElementById('training').getContext('2d');
			new Chart(ctx, {
				type: 'pie',
				data: {
					labels: ['En ligne', 'Présentiel'],
					datasets: [{
						data: [this.training.online, this.training.faceToFace],
						backgroundColor: ['#FF6384', '#36A2EB'],
						borderWidth: 0
					}]
				},
				options: {
					plugins: {
						legend: {
							position: 'bottom',
							labels: {
								font: {
									size: 12
								},
								padding: 20
							}
						}
					}
				}
			});
		},
		
		documentChart() {
			const ctx = document.getElementById('document').getContext('2d');
			new Chart(ctx, {
				type: 'polarArea',
				data: {
					labels: this.document_labels,
					datasets: [{
						data: this.document_numbers,
						backgroundColor: [
							'rgba(255, 99, 132, 0.7)',
							'rgba(54, 162, 235, 0.7)',
							'rgba(255, 206, 86, 0.7)',
							'rgba(75, 192, 192, 0.7)',
							'rgba(153, 102, 255, 0.7)',
							'rgba(255, 159, 64, 0.7)'
						],
						borderWidth: 0
					}]
				},
				options: {
					plugins: {
						legend: {
							position: 'bottom',
							labels: {
								font: {
									size: 10
								}
							}
						}
					}
				}
			});
		},
		
		jobContractChart() {
			const ctx = document.getElementById('job_contract').getContext('2d');
			new Chart(ctx, {
				type: 'pie',
				data: {
					labels: this.job_contract_labels,
					datasets: [{
						data: this.job_contract_numbers,
						backgroundColor: [
							'#FF9F40',
							'#4BC0C0',
							'#9966FF',
							'#FFCD56'
						],
						borderWidth: 0
					}]
				},
				options: {
					plugins: {
						legend: {
							position: 'bottom',
							labels: {
								font: {
									size: 10
								}
							}
						}
					}
				}
			});
		},
		
		jobStatusChart() {
			const ctx = document.getElementById('job_status').getContext('2d');
			new Chart(ctx, {
				type: 'doughnut',
				data: {
					labels: this.job_status_labels,
					datasets: [{
						data: this.job_status_numbers,
						backgroundColor: [
							'#36A2EB',
							'#FF6384',
							'#FFCE56'
						],
						borderWidth: 0
					}]
				},
				options: {
					cutout: '60%',
					plugins: {
						legend: {
							position: 'bottom',
							labels: {
								font: {
									size: 10
								}
							}
						}
					}
				}
			});
		},
		
		applicationGenderChart() {
			const ctx = document.getElementById('application_gender').getContext('2d');
			new Chart(ctx, {
				type: 'pie',
				data: {
					labels: this.application_gender_labels,
					datasets: [{
						data: this.application_gender_numbers,
						backgroundColor: ['#FF6384', '#36A2EB'],
						borderWidth: 0
					}]
				},
				options: {
					plugins: {
						legend: {
							position: 'bottom',
							labels: {
								font: {
									size: 10
								}
							}
						}
					}
				}
			});
		},
		
		applicationStatusChart() {
			const ctx = document.getElementById('application_status').getContext('2d');
			new Chart(ctx, {
				type: 'doughnut',
				data: {
					labels: this.application_status_labels,
					datasets: [{
						data: this.application_status_numbers,
						backgroundColor: [
							'#FF6384',
							'#36A2EB',
							'#FFCE56'
						],
						borderWidth: 0
					}]
				},
				options: {
					cutout: '60%',
					plugins: {
						legend: {
							position: 'bottom',
							labels: {
								font: {
									size: 10
								}
							}
						}
					}
				}
			});
		},
		
		salesChart() {
			const ctx = document.getElementById('sales').getContext('2d');
			new Chart(ctx, {
				type: 'line',
				data: {
					labels: ['HT', 'TVA', 'TTC'],
					datasets: [{
						label: 'Montant',
						data: [this.sales.amountHT, this.sales.tva, this.sales.amountTTC],
						backgroundColor: 'rgba(54, 162, 235, 0.2)',
						borderColor: 'rgba(54, 162, 235, 1)',
						borderWidth: 2,
						tension: 0.4,
						fill: true
					}]
				},
				options: {
					responsive: true,
					scales: {
						y: {
							beginAtZero: true,
							ticks: {
								font: {
									size: 12
								}
							}
						},
						x: {
							ticks: {
								font: {
									size: 12
								}
							}
						}
					},
					plugins: {
						legend: {
							display: false
						}
					}
				}
			});
		},
		
		buyingsChart() {
			const ctx = document.getElementById('buyings').getContext('2d');
			new Chart(ctx, {
				type: 'line',
				data: {
					labels: ['HT', 'TVA', 'TTC'],
					datasets: [{
						label: 'Montant',
						data: [this.buyings.amountHT, this.buyings.tva, this.buyings.amountTTC],
						backgroundColor: 'rgba(255, 99, 132, 0.2)',
						borderColor: 'rgba(255, 99, 132, 1)',
						borderWidth: 2,
						tension: 0.4,
						fill: true
					}]
				},
				options: {
					responsive: true,
					scales: {
						y: {
							beginAtZero: true,
							ticks: {
								font: {
									size: 12
								}
							}
						},
						x: {
							ticks: {
								font: {
									size: 12
								}
							}
						}
					},
					plugins: {
						legend: {
							display: false
						}
					}
				}
			});
		}
	},
	created() {
		this.loadList();
	}
};
</script>

<style scoped>
.dashboard-container {
	background-color: #f8f9fa;
	min-height: 100vh;
}

.dashboard-card {
	background: white;
	border-radius: 12px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
	overflow: hidden;
	transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.dashboard-card:hover {
	transform: translateY(-5px);
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.card-header {
	padding: 20px 20px 10px;
	border-bottom: 1px solid #eee;
}

.card-title {
	font-size: 14px;
	color: #6c757d;
	margin-bottom: 5px;
	font-weight: 500;
}

.card-subtitle {
	font-size: 18px;
	color: #343a40;
	font-weight: 600;
	margin-bottom: 0;
}

.chart-container {
	padding: 15px;
	position: relative;
	height: calc(100% - 70px);
}

/* Responsive adjustments */
@media (max-width: 768px) {
	.dashboard-card {
		margin-bottom: 20px;
	}
	
	.card-title {
		font-size: 12px;
	}
	
	.card-subtitle {
		font-size: 16px;
	}
}
</style>
